import React from 'react';

function SubSection({ label, children }) {
  return (
    <div className="flex flex-col p-3 gap-y-3 shadow rounded">
      <h4>{label}</h4>
      {children || <div className="empty-section-message">Aucune donnée</div>}
    </div>
  );
}

export default SubSection;
